//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex'

export default {
  name: "LayoutAside",
  data: () => ({}),
  created() {
    // this.$store.dispatch('competition/init')
    this.$store.dispatch('initMenuHeader')
  },
  computed: {
    ...mapGetters({
      getMenuHeader: 'getMenuHeader',
      getAvailableStatuses: 'competition/getAvailableStatuses',
      getStatusCode: 'competition/getStatusCode',
      getDisciplinesLength: 'tests/getDisciplinesLength',
      needHelp: 'needHelp/get'
    }),
    menuItems() {
      return this.getMenuHeader
      // const applicationStatusAccepted = this.getStatusCode === this.getAvailableStatuses[['APPLICATION_STATUS_ACCEPTED']]
      // if (this.getMenuHeader.length > 1) {
      //   return this.getMenuHeader.map((item) => {
      //     let modifiedElement = {...item, visible: false}
      //     if (item.link === '/cabinet/tests') {
      //       if (applicationStatusAccepted && !!this.getDisciplinesLength) {
      //         modifiedElement.visible = true
      //       }
      //     } else if (item.link === '/contracts') {
      //       if (applicationStatusAccepted) {
      //         modifiedElement.visible = true
      //       }
      //     } else {
      //       modifiedElement.visible = true
      //     }
      //     return modifiedElement
      //   })
      // } else {
      //   this.getMenuHeader.forEach(item => {
      //     item.visible = true;
      //   });
      //   return this.getMenuHeader;
      // }

    },
  },
  methods: {
    scrollTop(link) {
      if (link !== '/cabinet#FAQ') {
        window.scrollTo(0, 0)
      }
    }
  },
}
